import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import TasksRoute from "./TasksRoute";
import TaskViewRoute from "./TaskViewRoute";

export const tasksRoute: NonIndexRouteObject = {
  element: <TasksRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      element: <Navigate to=".." replace={true} />,
    },
    {
      path: ":taskId",
      element: <TaskViewRoute />,
    },
    // https://anvil.gearbox.foundation/forks/PeripheryNext/artifacts/view/optimist-ts-next/1745970093-sXHBi5EB/output/pNIExmgqcnN98MzgNsF1p.trace
    // https://anvil.gearbox.foundation/forks/PeripheryNext/tasks/sXHBi5EB
    // https://anvil.gearbox.foundation/forks/PeripheryNext/tasks/sXHBi5EB/trace/X8449eLtaJ9y9sMTKZ1P9.trace
  ],
};
